// extracted by mini-css-extract-plugin
export var chevronIcon = "_9o-2";
export var teamName = "_9o-1";
export var teamSwitcherButton = "_9o-0";